export enum Country {
  Slovakia = 'sk',
  Czechia = 'cz',
  Ukraine = 'ua',
  Poland = 'pl',
  World = 'en',
}
